module.exports = __webpack_public_path__ + "static/media/img07.b21be068.JPG";